<template>
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="22"
		height="24"
		viewBox="0 0 22 24"
		fill="none"
	>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M3.51709 12C3.51709 11.5858 3.82489 11.25 4.20459 11.25L17.7973 11.25C18.1769 11.25 18.4848 11.5858 18.4848 12C18.4848 12.4142 18.1769 12.75 17.7973 12.75L4.20459 12.75C3.82489 12.75 3.51709 12.4142 3.51709 12Z"
			fill="white"
		/>
	</svg>
</template>
